.suggestions {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding-bottom: 80px;
}

.address {
  display: flex;
  flex-direction: row;
  padding: 20px;
  width: 100%;
  cursor: pointer;
  color: var(--bloom-colors-header-contrast-text-label);
  border-bottom: 1px solid var(--bloom-colors-store-card-border);
}
